import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const CampaignTitle = React.memo(({ permissions }) => {
  const i18n = useContext(I18nContext);
  const IsRenameHotelToLodgingEnabled = permissions && permissions.dynamic && permissions.dynamic.IsRenameHotelToLodgingEnabled;
  return (
    <div className={classnames('campaign-title', 'section')}>
      <div className="title">
        { IsRenameHotelToLodgingEnabled ? i18n.getString(_TL_('Create a lodging campaign')) : i18n.getString(_TL_('Create a hotel campaign'))}
      </div>
    </div>);
});
CampaignTitle.propTypes = {
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      IsRenameHotelToLodgingEnabled: PropTypes.bool,
    }),
  }),
};

CampaignTitle.defaultProps = {
  permissions: {
    dynamic: {
      IsRenameHotelToLodgingEnabled: false,
    },
  },
};
